import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  toast: {
    minHeight: '3rem',
  },
}));
